import Vue from 'vue'

/**
 * Le stock de badges (ZEborne seul) : le référentiel (fournisseurs, modèles, dépôts), les lots reçus, les badges.
 * En GET, les paramètres passent par `data` (auth.fetch ne recopie pas `params`).
 */
class BadgeInventoryRepository {

  // GET → { suppliers, models, colors, locations }
  catalogue() {
    return this.fetch({ url: '/api/badge-inventory/catalogue', method: 'get' })
  }

  // POST (sans id) ou PUT → { id }
  saveSupplier(supplier) {
    return this.save('suppliers', supplier)
  }

  saveModel(model) {
    return this.save('models', model)
  }

  saveColor(color) {
    return this.save('colors', color)
  }

  saveLocation(location) {
    return this.save('locations', location)
  }

  // GET → { totals, depots, belowThreshold, batchesToCheck, batchesBlocked }
  overview() {
    return this.fetch({ url: '/api/badge-inventory/overview', method: 'get' })
  }

  batches() {
    return this.fetch({ url: '/api/badge-inventory/batches', method: 'get' })
  }

  batch(id) {
    return this.fetch({ url: `/api/badge-inventory/batches/${id}`, method: 'get' })
  }

  // Le fichier et ce qu'on dit du lot (fournisseur, dépôt, valeurs par défaut) → chaque ligne prête, connue ou en erreur
  previewImport(batch, file) {
    return this.fetch({ url: '/api/badge-inventory/batches/import-preview', method: 'post', data: this.form(batch, file) })
  }

  // → { id, number, imported, known, errors }
  importBatch(batch, file) {
    return this.fetch({ url: '/api/badge-inventory/batches', method: 'post', data: this.form(batch, file) })
  }

  importTemplate() {
    return Vue.auth.download({ url: '/api/badge-inventory/batches/template', method: 'get' })
  }

  // { checkedUid?, reason? }
  release(id, body) {
    return this.fetch({ url: `/api/badge-inventory/batches/${id}/release`, method: 'post', data: body })
  }

  // { unblock?, reason? }
  block(id, body) {
    return this.fetch({ url: `/api/badge-inventory/batches/${id}/block`, method: 'post', data: body })
  }

  // POST { organizationId, identifiers[], comment? } → { handedOut: uid[], refused: [{ identifier, reason }] } : remettre
  // des badges du stock à une organisation, sans les activer (reason : not-found, ambiguous, not-available, batch-not-released)
  handOut(body) {
    return this.fetch({ url: '/api/badge-inventory/hand-outs', method: 'post', data: body })
  }

  // { search?, batchId?, modelId?, colorId? ('none' : sans couleur), locationId?, status?, ownerOrganizationId?, page, itemsPerPage } → { items, total, statusCounts }
  badges(filters) {
    return this.fetch({ url: '/api/badge-inventory/badges', method: 'get', data: filters })
  }

  badge(id) {
    return this.fetch({ url: `/api/badge-inventory/badges/${id}`, method: 'get' })
  }

  save(collection, item) {
    const { id, ...body } = item
    return id
      ? this.fetch({ url: `/api/badge-inventory/${collection}/${id}`, method: 'put', data: body })
      : this.fetch({ url: `/api/badge-inventory/${collection}`, method: 'post', data: body })
  }

  form(batch, file) {
    const data = new FormData()
    data.append('batch', JSON.stringify(batch))
    data.append('file', file)
    return data
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new BadgeInventoryRepository()
